import { MembershipService } from './../../../profile/membership/membership.service';
import { Component } from '@angular/core';
import { ViewController, NavParams, LoadingController, AlertController, ModalController } from 'ionic-angular';
import { ReservationsService } from '../../../../../services/reservations';
import { SessionService } from '../../../../../services/session';
import { LocationsService } from '../../../../../services/locations';
import { ExtraClassPage } from './extra-class/extra-class';
// pwa/app difference: App uses Ionic native calendar

@Component({
    selector: 'page-confirm',
    templateUrl: 'confirm.html'
})
export class ConfirmPage {

    public lesson:any=null;
    public addToCalendar=true;
    public bookClicked=false;
    public canCancel:boolean;
    public acknowledgesCanNotCancel=false;

    constructor(private readonly viewCtrl: ViewController,
                private readonly navParams: NavParams,
                private readonly reservationsService: ReservationsService,
                private readonly loadingCtrl:LoadingController,
                private readonly alertCtrl:AlertController,
                private readonly modalCtrl: ModalController,
                private readonly sessionService: SessionService,
                public readonly membershipService: MembershipService,
                public readonly locationsService:LocationsService ){
        this.lesson = navParams.get('lesson');
        this.canCancel = navParams.get('canCancel');
    }

    public dismissModal(reservationId?) {
        this.viewCtrl.dismiss(reservationId);
    }

    public bookClass(extras = false): void{
        let loading = this.loadingCtrl.create();
        loading.present();
        this.bookClicked = true;
        this.reservationsService.bookClass(this.lesson.gym.id, this.lesson.id, this.lesson.schedule.id, extras)
        .then((message:any)=>{
          loading.dismiss();
          this.dismissModal(message.reservation_id);
        } )
        .catch(err=>{
            loading.dismiss();
            this.handleBookError(err)
        })
    }

    private handleBookError(err:any): void {
        console.log(err)
        const { error } = err;
        if(error.extras || typeof error.extras === 'number'){
            this.showExtraClassModal(this.getExtraClassPrice(error.extras))
        } else {
            this.reportError(error);
            this.showCannotBookAlert(error.errors[0])
        }
    }

    private getExtraClassPrice(extras: number | string | true): string | number{
        if(extras === true){
            return this.membershipService.extras;
        }
        return extras;
    }

    private showExtraClassModal(price: number | string): void {
        let modal = this.modalCtrl.create(ExtraClassPage, {
            price: price,
        }, {
            cssClass: 'smallest-modal'
        });
        modal.onDidDismiss((bookClass) => {
            if(bookClass){
                this.bookClass(true);
            } else{
                this.bookClicked = false;
            }
        });
        modal.present();
    }

    private reportError(error:any): void {
        this.sessionService.reportError(
            'confirmPage',
            'bookClass()',
            error
        );
    }

    private showCannotBookAlert(errorMessage:string){
        let alert = this.alertCtrl.create({
            title: 'Error',
            message: errorMessage,
            buttons: [
                {
                    text: 'OK',
                    role: 'cancel',
                },
            ]
        });
        alert.present();
        this.bookClicked = false;
    }

    public getClassInfo(info:string): string{
        const hoursToCancel = (this.lesson.schedule.hours_to_cancel ||
          this.membershipService.hoursToCancelClass).toString();
        return info.replace(this.membershipService.hoursToCancelClass.toString(), hoursToCancel)
    }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/class/confirm/confirm.ts